<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					:model="searchForm"
					@submit.native.prevent
        >
          <el-form-item label="专业名称:">
            <el-input 
								v-model.trim="searchForm.name"
								@keyup.enter.native="seach"
								clearable />
          </el-form-item>
          <el-form-item label="专业层次:">
            <el-select 
							v-model="searchForm.majorlevelval" 
							@keyup.enter.native="seach"
							@visible-change="visibleType"
							ref="selectRef"
							clearable>
              <el-option
                v-for="item in leveltype"
                :key="item.key"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业类别:">
            <el-select 
							v-model="searchForm.majortypeval"
							@keyup.enter.native="seach"
							@visible-change="visileMajor"
							ref="marjorref"
							clearable>
              <el-option
                v-for="item in majortype"
                :key="item.key"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
					<el-form-item label="院校:">
					  <el-input 
								v-model.trim="searchForm.collegename"
								@keyup.enter.native="seach"
								clearable />
					</el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      stripe
      border
      :header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      :cell-style="{ padding: 0 }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
			<el-table-column label="流水号" prop="id" align="center"/>
			<el-table-column label="院校名称" prop="collegename" align="center"/>
      <el-table-column label="专业" prop="name" align="center">
        <template slot-scope="scope">
          <el-button @click="btnShowDetail(scope.row)" type="text">{{
            scope.row.name
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="层次" prop="majorlevelval" align="center" />
			<el-table-column label="类别" prop="majortypeval" align="center" />
			<el-table-column label="学制" prop="xuezhi" align="center" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
			:close-on-click-modal='false'
      width="60%"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
      append-to-body
			:title="this.dialogTitle "
    >
			<div class="show_detail_w">
				<el-form
				  :model="dynamicValidateForm"
				  ref="dynamicValidateForm"
				  class="demo-dynamic form-item-w-50"
				  status-icon
				  :rules="rules"
				>
				<div class="major_list">
					<div class="major_title">
							{{dynamicValidateForm.name}}
					</div>
					<el-row>
						<el-col :span="12" v-for="(item, i) in dynamicValidateForm.list" :key="i" class="col_content">
							<div>{{ item.collegename }}</div>
						</el-col>
					</el-row>
				</div>
				</el-form>
			</div>
    </el-dialog>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
      width="35%"
			v-dialogDrag
			:close-on-click-modal='false'
      :title="dialogTitle"
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="院校名称:" prop="collegename">
          <el-input v-model="dynamicValidateForm.collegename" disabled />
          <el-button
            type="primary"
            class="select-btn"
            @click="onSelectData(college_dialogresult, 'showAcademyModal')"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="专业名称:" prop="name">
          <el-input v-model.trim="dynamicValidateForm.name" clearable/>
        </el-form-item>
        <el-form-item label="专业层次:" prop="majorlevelkey">
          <el-select v-model="dynamicValidateForm.majorlevelkey" clearable>
            <el-option
              v-for="item in leveltype"
              :value="item.key"
              :key="item.key"
              :label="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业类别:" prop="majortypekey">
          <el-select v-model="dynamicValidateForm.majortypekey" clearable>
            <el-option
              v-for="item in majortype"
              :value="item.key"
              :key="item.key"
              :label="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学制:" prop="xuezhi">
          <el-select v-model="dynamicValidateForm.xuezhi" clearable>
            <el-option
              v-for="item in xuezhiList"
              :value="item.key"
              :key="item.key"
              :label="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 院校列表 -->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
			width="60%"
      title="院校列表："
			:close-on-click-modal='false'
      :visible.sync="showAcademyModal"
      v-if="showAcademyModal"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmAcademy">确定</el-button>

      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="院校名称:" prop="name">
              <el-input 
								v-model.trim="selectSearchForm.name" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>

      <el-table
        :data="selectTable.list"
        style="width: 100%"
				stripe
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="院校名称" prop="name" align="center" />
        <el-table-column label="学院编号" prop="code" align="center" />
      </el-table>
      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(val, Object.assign({}, selectSearchForm))
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <Export
      :exportTitle="'院校管理'"
      :transferDialog="transferDialog"
      :exportUrl="exportUrl"
      :exportexcelUrl="exportexcelUrl"
      :exportsaveUrl="exportsaveUrl"
      :searchForm="searchForm"
      @onCloseExport="onCloseExport"
    ></Export>

    <Import
      :importDialog="importDialog"
      :importSaveUrl="importSaveUrl"
      @onCloseImport="onCloseImport"
      @getDataList="getDataList"
      downloadUrl="download/教学管理/学历/院校专业导入模板.xls"
    ></Import>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import Export from "@/components/Export/index.vue";
import Import from "@/components/Import/index.vue";
import {
  collegemajor_list,
  collegemajor_input,
  collegemajor_save,
  collegemajor_delete,
  collegemajor_export,
  collegemajor_exportexcel,
  collegemajor_exportsave,
  college_dialogresult,
  college_getcollegeinfo,
  collegemajor_importsave,
  collegemajor_show,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import { _pictureupload_save } from "@/request/api/public";
import { _collegetype } from "@/assets/js/filedValueFlag";
export default {
  mixins: [part],
  name: "collegemajor",
  components: { Export, Import },
  props: {
    exportUrl: {
      default: () => collegemajor_export,
    },
    exportexcelUrl: {
      default: () => collegemajor_exportexcel,
    },
    exportsaveUrl: {
      default: () => collegemajor_exportsave,
    },
    importSaveUrl: {
      default: () => collegemajor_importsave,
    },
    college_dialogresult: {
      default: () => college_dialogresult,
    },
  },
  data() {
    return {
      transferDialog: false, //导出框
      importDialog: false, //导入框
      // 是否招生
      enableflag: {
        1: "是",
        0: "否",
      },
      collegetype: _collegetype, //院校类型（1成考  3网络教育  4自考 ）
      itemId: null, //首表格项id
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, // 添加
      showDetailModal: false, // 查看详情
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        collegename: [{ trigger: "blur", message: "必填字段", required: true }],
        name: [{ trigger: "blur", message: "必填字段", required: true }],
        majorlevelkey: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        majortypekey: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        enableflag: [{ trigger: "blur", message: "必填字段", required: true }],
        rank: [{ trigger: "blur", message: "必填字段", required: true }],
        xuezhi: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则
      dialogTitle: "", //对话框标题
      fds: new FormData(),
      majortype: [],
      leveltype: [],
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      showAcademyModal: false,

      selectSchoolorgid: null,
      selectTableUrl: null,
      selectTable: {}, //院校列表
      selectSearchForm: {},

      xuezhiList: [], //学制
    };
  },
  created() {
    this.getDataList();
    this.dic_combox({
      list: "majortype",
      typecode: "majortype",
      that: this,
    });
    this.dic_combox({
      list: "leveltype",
      typecode: "leveltype",
      that: this,
    });
    this.dic_combox({
      list: "xuezhiList",
      typecode: "xuezhi",
      that: this,
    });
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", ["dic_combox"]),

    //关闭导入框
    onCloseImport(bool) {
      this.importDialog = bool;
    },
    //导入 click
    btnImport() {
      this.importDialog = true;
    },
    //关闭导出框
    onCloseExport(bool) {
      this.transferDialog = false;
    },
    //导出 click
    btnExport() {
      this.transferDialog = true;
    },
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.selectRef.blur();
			}
		},
		visileMajor(e) {
			if(!e) {
				this.$refs.marjorref.blur();
			}
		},
		reset() {
			this.searchForm = {
				name: null,
				majorlevelval: null,
				majortypeval: null,
				collegename: null
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
		selectQuery() {
			this.selectSearchForm = {
				name: null
			}
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, null);
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: collegemajor_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },

    // 查看详情 api
    btnShowDetail(row) {
      this.dynamicValidateForm.name = row.name
      myRequest({
        url: collegemajor_show,
        data: {
          name:row.name,
          majorlevelval:row.majorlevelval,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showDetailModal = true;
          this.dialogTitle = "查看";
          this.dynamicValidateForm.list = res.data.data.list
        }
      });
    },

    //添加click
    btnAdd() {
      this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        rank: 0,
      };
      this.showAddModal = true;
    },
    //修改click
    btnEdit() {
      this.dialogTitle = "修改";
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoutePage(this.multipleSelection[0].id);
      });
    },
    //确认院校 click
    onConfirmAcademy() {
      selectCheck(this.multipleSelection, "确认院校", false, () => {
       this.$set(
          this.dynamicValidateForm,
          "collegename",
          this.multipleSelection[0].name
        );
        this.dynamicValidateForm.collegeid = this.multipleSelection[0].id;
        this.showAcademyModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },
    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //上传文件前 before
    beforeUpload(file) {
      this.fds.append("upfile", file); // 传文件
    },
    //上传文件 upload
    uploadFile() {
      myRequest({
        method: "post",
        url: _pictureupload_save,
        data: this.fds,
      }).then((res) => {
        if (res.data.code === "200") {
          this.dynamicValidateForm.fileurl = res.data.url;
        }
      });
    },
    //刷新 click
    btnReload() {
      this.getDataList();
    },
    //修改路由页 api
    editRoutePage(id) {
      myRequest({
        url: collegemajor_input,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showAddModal = true;
          this.dynamicValidateForm = res.data.data.tcollegemajor;
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
        }
      });
    },
    //提交-（添加，修改） api
    submitAddOrEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: collegemajor_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,

              modal: "showAddModal",
            }
          );
        }
      });
    },
    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: collegemajor_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },

    //切换选项表格页
    handleSelectChange(val, data) {
      this.selectPageInfo.pageindex = val;
      this.onSelectData(this.selectTableUrl, null, data);
			this.onCloseSelect();
    },

    //选中表格数据改变时 change
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //选项表格 api(院校列表)
    onSelectData(url, modal, data) {
      this.selectTableUrl = url;
      myRequest({
        url: this.selectTableUrl,
        data: Object.assign(data || {}, this.selectPageInfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
          this.selectTable = res.data.data;
          this[modal] = true;
        }
      });
    },
    //选项表格 - 搜索 click
    onSelectSearchClick(url, modal, data) {
      this.selectPageInfo.pageindex = 1;
      this.onSelectData(url, modal, data);
    },
    //关闭选项框 click
    onCloseSelect() {
      this.selectPageInfo.pageindex = 1;
    },
  },
};
</script>

<style  lang="scss">
	.table_el{
		display: flex;
		tr{
			flex: 1;
		}
	}
	.major_list{
		border: 1px solid #dbdada;
		display: table;
		width: 750px;
		.major_title{
			padding-top: 15px;
			padding-bottom: 15px;
			text-align: center;
		}
		.col_content{
			border-top: 1px solid #dbdada;
			border-right: 1px solid #dbdada;
			text-align:center;
			padding-top: 15px;
			padding-bottom: 15px;
		}
	}
</style>